module.exports = __webpack_public_path__ + "static/media/About_ProCompPPR.5f1de2a3.png";